import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `/:companyId${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "login-wo-company",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "create-project",
    path: `/:companyId/verify/project`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/verify/create-project")
    ),
  },
  {
    key: "create-account",
    path: `/:companyId/verify/createAccount`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/verify/create-account")
    ),
  },
  {
    key: "change-account",
    path: `/:companyId/verify/confirmAccount`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/verify/change-account")
    ),
  },
  {
    key: "initialize-password",
    path: `/:companyId/verify/initPassword`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/verify/initialize-password")
    ),
  },

  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register-2")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "nbase-projects",
    path: `/:companyId/projects`,
    component: React.lazy(() => import("views/app-views/projects")),
    meta: {
      blankLayout: true,
    },
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.integrated",
    path: `${APP_PREFIX_PATH}/dashboards/integrated`,
    component: React.lazy(() => import("views/app-views/dashboards/integrated")),
  },
  {
    key: "dashboard.sales",
    path: `${APP_PREFIX_PATH}/dashboards/sales`,
    component: React.lazy(() => import("views/app-views/dashboards/sales")),
  },
  {
    key: "analytics.user",
    path: `${APP_PREFIX_PATH}/analytics/user`,
    component: React.lazy(() => import("views/app-views/analytics/user")),
  },
  {
    key: "analytics.sales",
    path: `${APP_PREFIX_PATH}/analytics/sales`,
    component: React.lazy(() => import("views/app-views/analytics/sales")),
  },
  {
    key: "analytics.retention",
    path: `${APP_PREFIX_PATH}/analytics/retention`,
    component: React.lazy(() => import("views/app-views/analytics/retention")),
  },
  {
    key: "analytics.funnel",
    path: `${APP_PREFIX_PATH}/analytics/funnel`,
    component: React.lazy(() => import("views/app-views/analytics/funnel")),
  },
  {
    key: "analytics.segment",
    path: `${APP_PREFIX_PATH}/analytics/segment`,
    component: React.lazy(() => import("views/app-views/analytics/segment")),
  },
  {
    key: "analytics.ccu",
    path: `${APP_PREFIX_PATH}/analytics/ccu`,
    component: React.lazy(() => import("views/app-views/analytics/ccu")),
  },
  {
    key: "operation.user.list",
    path: `${APP_PREFIX_PATH}/operation/user/list`,
    component: React.lazy(() => import("views/app-views/operation/user/list")),
  },
  {
    key: "operation.user.dau",
    path: `${APP_PREFIX_PATH}/operation/user/dau`,
    component: React.lazy(() => import("views/app-views/operation/user/dau")),
  },
  {
    key: "operation.user.nru",
    path: `${APP_PREFIX_PATH}/operation/user/nru`,
    component: React.lazy(() => import("views/app-views/operation/user/nru")),
  },
  {
    key: "operation.user.ccu",
    path: `${APP_PREFIX_PATH}/operation/user/ccu`,
    component: React.lazy(() => import("views/app-views/operation/user/ccu")),
  },
  {
    key: "operation.user.suspended",
    path: `${APP_PREFIX_PATH}/operation/user/suspended`,
    component: React.lazy(() =>
      import("views/app-views/operation/user/suspended")
    ),
  },
  {
    key: "operation.purchase.list",
    path: `${APP_PREFIX_PATH}/operation/purchase/list`,
    component: React.lazy(() =>
      import("views/app-views/operation/purchase/list")
    ),
  },
  {
    key: "operation.purchase.in_app_purchase",
    path: `${APP_PREFIX_PATH}/operation/purchase/in_app_purchase`,
    component: React.lazy(() =>
      import("views/app-views/operation/purchase/in_app_purchase")
    ),
  },
  {
    key: "operation.purchase.statistics",
    path: `${APP_PREFIX_PATH}/operation/purchase/statistics`,
    component: React.lazy(() =>
      import("views/app-views/operation/purchase/statistics")
    ),
  },
  {
    key: "operation.purchase.canceled_payment",
    path: `${APP_PREFIX_PATH}/operation/purchase/canceled_payment`,
    component: React.lazy(() =>
      import("views/app-views/operation/purchase/canceled_payment")
    ),
  },
  {
    key: "operation.purchase.external_payment",
    path: `${APP_PREFIX_PATH}/operation/purchase/external_payment`,
    component: React.lazy(() =>
      import("views/app-views/operation/purchase/external_payment")
    ),
  },
  {
    key: "operation.maintenance_and_update.maintenance",
    path: `${APP_PREFIX_PATH}/operation/maintenance_and_update/maintenance`,
    component: React.lazy(() =>
      import("views/app-views/operation/maintenance_and_update/maintenance")
    ),
  },
  {
    key: "operation.maintenance_and_update.update",
    path: `${APP_PREFIX_PATH}/operation/maintenance_and_update/update`,
    component: React.lazy(() =>
      import("views/app-views/operation/maintenance_and_update/update")
    ),
  },
  {
    key: "operation.message.push_notification",
    path: `${APP_PREFIX_PATH}/operation/message/push_notification`,
    component: React.lazy(() =>
      import("views/app-views/operation/message/push_notification")
    ),
  },
  {
    key: "operation.message.text_message",
    path: `${APP_PREFIX_PATH}/operation/message/text_message`,
    component: React.lazy(() =>
      import("views/app-views/operation/message/text_message")
    ),
  },
  {
    key: "operation.coupon.general_coupon",
    path: `${APP_PREFIX_PATH}/operation/coupon/general_coupon`,
    component: React.lazy(() =>
      import("views/app-views/operation/coupon/general")
    ),
  },
  {
    key: "operation.coupon.keyword_coupon",
    path: `${APP_PREFIX_PATH}/operation/coupon/keyword_coupon`,
    component: React.lazy(() =>
      import("views/app-views/operation/coupon/keyword")
    ),
  },
  {
    key: "operation.coupon.coupon_usage",
    path: `${APP_PREFIX_PATH}/operation/coupon/coupon_usage`,
    component: React.lazy(() =>
      import("views/app-views/operation/coupon/usage")
    ),
  },
  {
    key: "operation.customer_support.dashboard",
    path: `${APP_PREFIX_PATH}/operation/customer_support/dashboard`,
    component: React.lazy(() =>
      import("views/app-views/operation/customer_support/dashboard")
    ),
  },
  {
    key: "operation.customer_support.customer_inquiry",
    path: `${APP_PREFIX_PATH}/operation/customer_support/customer_inquiry/*`,
    component: React.lazy(() =>
      import("views/app-views/operation/customer_support/customer_inquiry")
    ),
  },
  {
    key: "operation.customer_support.statistics",
    path: `${APP_PREFIX_PATH}/operation/customer_support/statistics`,
    component: React.lazy(() =>
      import("views/app-views/operation/customer_support/statistics")
    ),
  },
  {
    key: "operation.customer_support.reviews",
    path: `${APP_PREFIX_PATH}/operation/customer_support/reviews`,
    component: React.lazy(() =>
      import("views/app-views/operation/customer_support/reviews")
    ),
  },
  {
    key: "operation.customer_support.custom_page",
    path: `${APP_PREFIX_PATH}/operation/customer_support/custom_page`,
    component: React.lazy(() =>
      import("views/app-views/operation/customer_support/custom_page")
    ),
  },
  {
    key: "operation.customer_support.settings",
    path: `${APP_PREFIX_PATH}/operation/customer_support/settings/*`,
    component: React.lazy(() =>
      import("views/app-views/operation/customer_support/settings")
    ),
  },
  {
    key: "setting.project_settings.general",
    path: `${APP_PREFIX_PATH}/setting/project_settings/general`,
    component: React.lazy(() =>
      import("views/app-views/setting/project_settings/general")
    ),
  },
  {
    key: "setting.project_settings.authentication",
    path: `${APP_PREFIX_PATH}/setting/project_settings/authentication`,
    component: React.lazy(() =>
      import("views/app-views/setting/project_settings/authentication")
    ),
  },
  {
    key: "setting.project_settings.store",
    path: `${APP_PREFIX_PATH}/setting/project_settings/store`,
    component: React.lazy(() =>
      import("views/app-views/setting/project_settings/store")
    ),
  },
  {
    key: "setting.project_settings.integration",
    path: `${APP_PREFIX_PATH}/setting/project_settings/integration`,
    component: React.lazy(() =>
      import("views/app-views/setting/project_settings/integration")
    ),
  },
  {
    key: "setting.project_settings.payment",
    path: `${APP_PREFIX_PATH}/setting/project_settings/payment`,
    component: React.lazy(() =>
      import("views/app-views/setting/project_settings/payment")
    ),
  },
  {
    key: "setting.project_settings.api_key",
    path: `${APP_PREFIX_PATH}/setting/project_settings/api_key`,
    component: React.lazy(() =>
      import("views/app-views/setting/project_settings/api_key")
    ),
  },
  {
    key: "setting.profile_settings",
    path: `${APP_PREFIX_PATH}/setting/profile_settings`,
    component: React.lazy(() =>
      import("views/app-views/setting/profile_settings")
    ),
  },
  {
    key: "setting.admin.list",
    path: `${APP_PREFIX_PATH}/setting/admin/list`,
    component: React.lazy(() => import("views/app-views/setting/admin/list")),
  },
  {
    key: "setting.admin.export",
    path: `${APP_PREFIX_PATH}/setting/admin/export`,
    component: React.lazy(() => import("views/app-views/setting/admin/export")),
  },
  {
    key: "setting.admin.authority",
    path: `${APP_PREFIX_PATH}/setting/admin/authority`,
    component: React.lazy(() =>
      import("views/app-views/setting/admin/authority")
    ),
  },
  {
    key: "setting.admin.admin_log",
    path: `${APP_PREFIX_PATH}/setting/admin/admin_log`,
    component: React.lazy(() =>
      import("views/app-views/setting/admin/admin_log")
    ),
  },
  // {
  //   key: "download.sdk_download.android",
  //   path: `${APP_PREFIX_PATH}/download/sdk_download/android`,
  //   component: React.lazy(() =>
  //     import("views/app-views/download/sdk_download/android")
  //   ),
  // },
  // {
  //   key: "download.sdk_download.ios",
  //   path: `${APP_PREFIX_PATH}/download/sdk_download/ios`,
  //   component: React.lazy(() =>
  //     import("views/app-views/download/sdk_download/ios")
  //   ),
  // },
  // {
  //   key: "download.sdk_download.unity",
  //   path: `${APP_PREFIX_PATH}/download/sdk_download/unity`,
  //   component: React.lazy(() =>
  //     import("views/app-views/download/sdk_download/unity")
  //   ),
  // },
  // {
  //   key: "download.sdk_download.unreal",
  //   path: `${APP_PREFIX_PATH}/download/sdk_download/unreal`,
  //   component: React.lazy(() =>
  //     import("views/app-views/download/sdk_download/unreal")
  //   ),
  // },
  // {
  //   key: "error",
  //   path: `/error`,
  //   component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  //   meta: {
  //     blankLayout: true,
  //   },
  // },
  {
    key: "operation.user_management.player",
    path: `${APP_PREFIX_PATH}/operation/user_management/player`,
    component: React.lazy(() =>
      import("views/app-views/operation/user_management/player")
    ),
  },
  {
    key: "operation.user_management.friendship",
    path: `${APP_PREFIX_PATH}/operation/user_management/friendship`,
    component: React.lazy(() =>
      import("views/app-views/operation/user_management/friendship")
    ),
  },
  {
    key: "operation.user_management.blacklist",
    path: `${APP_PREFIX_PATH}/operation/user_management/blacklist`,
    component: React.lazy(() =>
      import("views/app-views/operation/user_management/blacklist")
    ),
  },
  {
    key: "operation.user_management.reservation",
    path: `${APP_PREFIX_PATH}/operation/user_management/reservation`,
    component: React.lazy(() =>
      import("views/app-views/operation/user_management/reservation")
    ),
  },
  {
    key: "chat.chanel",
    path: `${APP_PREFIX_PATH}/chat/chanel/*`,
    component: React.lazy(() =>
      import("views/app-views/chat/chanel")
    ),
  },
  {
    key: "chat.message",
    path: `${APP_PREFIX_PATH}/chat/message`,
    component: React.lazy(() =>
      import("views/app-views/chat/message")
    ),
  },
  {
    key: "chat.archive",
    path: `${APP_PREFIX_PATH}/chat/archive`,
    component: React.lazy(() =>
      import("views/app-views/chat/archive")
    ),
  },
  {
    key: "operation.communication.notice",
    path: `${APP_PREFIX_PATH}/operation/communication/notice`,
    component: React.lazy(() =>
      import("views/app-views/operation/communication/notice")
    ),
  },
  {
    key: "operation.communication.gift",
    path: `${APP_PREFIX_PATH}/operation/communication/gift`,
    component: React.lazy(() => 
      import("views/app-views/operation/communication/gift")
    ),
  },
  {
    key: "operation.game_content.item",
    path: `${APP_PREFIX_PATH}/operation/game_content/item`,
    component: React.lazy(() => 
      import("views/app-views/operation/game_content/item")
    ),
  },
  {
    key: "operation.game_content.ranking",
    path: `${APP_PREFIX_PATH}/operation/game_content/ranking`,
    component: React.lazy(() =>
      import("views/app-views/operation/game_content/ranking")
    ),
  },
  {
    key: "operation.game_content.matchmaking",
    path: `${APP_PREFIX_PATH}/operation/game_content/matchmaking`,
    component: React.lazy(() =>
      import("views/app-views/operation/game_content/matchmaking")
    ),
  },
  {
    key: "operation.operations_tools.data_store",
    path: `${APP_PREFIX_PATH}/operation/operations_tools/data_store`,
    component: React.lazy(() =>
      import("views/app-views/operation/operations_tools/data_store")
    ),
  },
  {
    key: "operation.operations_tools.remote_config",
    path: `${APP_PREFIX_PATH}/operation/operations_tools/remote_config`,
    component: React.lazy(() =>
      import("views/app-views/operation/operations_tools/remote_config")
    ),
  },
  {
    key: "operation.operations_tools.game_log",
    path: `${APP_PREFIX_PATH}/operation/operations_tools/game_log`,
    component: React.lazy(() =>
      import("views/app-views/operation/operations_tools/game_log")
    ),
  },
  {
    key: "operation.operations_tools.security",
    path: `${APP_PREFIX_PATH}/operation/operations_tools/security`,
    component: React.lazy(() =>
      import("views/app-views/operation/operations_tools/security")
    ),
  },
];
